import React from 'react'
import withLayout from '../../hocs/Layout'
import CodEmail from './CodEmail'
import PageTitle from '../../common/PageTitle'
import MisConfig from './MisConfig'
import LostAndDamageEmail from './LndConfig'
import WeightDiscrepancyEmail from './WdConfig'
import WalletEmailConfig from './Wallet'
import NDREmailConfig from './NdrConfig'
import {TabContext, TabPanel} from '@mui/lab'
import {Box} from '@mui/material'
import SummaryTabs from '../../common/SummaryTabs'
import {PRIMARY_BLUE, SUCCESS, ERROR} from '../../styles/foundation/colors'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined'
import NPREmailConfig from './NPREmilConfig'
import RTOEmailConfig from './RTOEmailConfig'
import RTORvpEmailConfig from './RtoRvpEmailconfig'
import {pageContainerSx, tabContainerSx, tabPanelSx} from '../../styles/patterns'

const EmailConfig = () => {
  const [value, setValue] = React.useState('1')

  return (
    <Box sx={pageContainerSx}>
      <PageTitle subTitle="Configure automated email notifications for shipment events">Email Configuration</PageTitle>
      <TabContext value={value}>
        <Box sx={tabContainerSx}>
          <SummaryTabs
            value={value}
            onChange={setValue}
            tabs={[
              { value: '1', label: 'COD', icon: <PaymentsOutlinedIcon />, color: SUCCESS },
              { value: '2', label: 'MIS', icon: <DescriptionOutlinedIcon />, color: PRIMARY_BLUE },
              { value: '3', label: 'Lost And Damage', icon: <ReportProblemOutlinedIcon />, color: ERROR },
              { value: '4', label: 'Weight Discrepancy', icon: <ScaleOutlinedIcon />, color: '#ff9800' },
              { value: '5', label: 'Wallet', icon: <AccountBalanceWalletOutlinedIcon />, color: SUCCESS },
              { value: '6', label: 'NDR', icon: <ErrorOutlineOutlinedIcon />, color: ERROR },
              { value: '7', label: 'NPR', icon: <EventBusyOutlinedIcon />, color: '#f5a524' },
              { value: '8', label: 'RTO', icon: <ReplayOutlinedIcon />, color: ERROR },
              { value: '9', label: 'RTO RVP', icon: <AssignmentReturnOutlinedIcon />, color: '#7c4dff' },
            ]}
          />
          <TabPanel value='1' sx={tabPanelSx}>
            <CodEmail />
          </TabPanel>
          <TabPanel value='2' sx={tabPanelSx}>
            <MisConfig />
          </TabPanel>
          <TabPanel value='3' sx={tabPanelSx}>
            <LostAndDamageEmail />
          </TabPanel>
          <TabPanel value='4' sx={tabPanelSx}>
            <WeightDiscrepancyEmail />
          </TabPanel>
          <TabPanel value='5' sx={tabPanelSx}>
            <WalletEmailConfig />
          </TabPanel>
          <TabPanel value='6' sx={tabPanelSx}>
            <NDREmailConfig />
          </TabPanel>
          <TabPanel value='7' sx={tabPanelSx}>
            <NPREmailConfig />
          </TabPanel>
          <TabPanel value='8' sx={tabPanelSx}>
            <RTOEmailConfig />
          </TabPanel>
          <TabPanel value='9' sx={tabPanelSx}>
            <RTORvpEmailConfig />
          </TabPanel>
        </Box>
      </TabContext>
    </Box>
  )
}

export default withLayout(EmailConfig)
